import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

import { ImpersonateService } from './impersonate.service';

@Injectable()
export class ImpersonateInterceptor implements HttpInterceptor {
  private readonly impersonateService = inject(ImpersonateService);

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const impersonateId = this.impersonateService.getImpersonateId();
    if (impersonateId == null) {
      return next.handle(request);
    } else {
      const modifiedRequest = request.clone({
        headers: request.headers.set('X-WO-Impersonate', `${impersonateId}`),
      });
      return next.handle(modifiedRequest);
    }
  }
}
